/**
 * @file Google Maps SDK loader.
 *
 * Injects the Maps JS script once, deduped via olmokit/loadjs by bundle key
 * (shared with Searchaddress so the SDK loads exactly once), with retries.
 * Resolves when ready; classes are then read directly off `google.maps.*`
 * (the URL loads `marker,places,geometry` eagerly, so everything is available
 * on load). Memoized so multiple callers share one load.
 */
import loadResource from "@olmokit/core/ajax/loadResource";
import { GMAP_ASYNC_BUNDLE_KEY, GMAP_SCRIPT_URL } from "config/index";

let promise: Promise<void> | null = null;

export function loadGoogleMaps(): Promise<void> {
  if (promise) return promise;
  promise = new Promise<void>((resolve, reject) => {
    const handlers = {
      success: () => resolve(),
      error: () => reject(new Error("Google Maps SDK failed to load")),
    };
    if (loadResource.isDefined(GMAP_ASYNC_BUNDLE_KEY)) {
      loadResource.ready([GMAP_ASYNC_BUNDLE_KEY], handlers);
    } else {
      loadResource([GMAP_SCRIPT_URL], GMAP_ASYNC_BUNDLE_KEY, {
        numRetries: 3,
        ...handlers,
      });
    }
  });
  return promise;
}
